import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { BureauFeatures } from './api'
import { getBureauFeatures, getBureauParent, updateBureauFeatures } from './endpoints'

export const QueryKeys = {
  BureauParent: (customerId: string) => ['bureau-parent', customerId] as const,
  BureauFeatures: (customerId: string) => ['bureau-features', customerId] as const,
}

export const useBureauParent = (customerId: string) => {
  return useQuery({
    queryKey: QueryKeys.BureauParent(customerId),
    queryFn: () => getBureauParent(customerId),
  })
}

export const useBureauFeatures = (customerId: string) => {
  return useQuery({
    queryKey: QueryKeys.BureauFeatures(customerId),
    queryFn: () => getBureauFeatures(customerId),
  })
}

export const useUpdateBureauFeatures = (customerId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (features: BureauFeatures) => updateBureauFeatures(customerId, features),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.BureauFeatures(customerId) })
    },
  })
}
